import {useDispatch,useSelector} from "react-redux";
import { API_OPTIONS } from "../utils/constants";
import { addPopularMovies } from "../utils/movieSlice";
import { useEffect } from "react";
const usePopularMovies=()=>{
    const dispatch=useDispatch()
    const movieData= async ()=>{
        const data=await fetch("https://api.themoviedb.org/3/movie/popular?language=en-US&page=1",API_OPTIONS)
        const json=await data.json();
        console.log(json)
        dispatch(addPopularMovies(json));
     
       }
       useEffect(()=>{
         movieData();
       },[])
}
export default usePopularMovies